import React from 'react';
import { MessageCircle } from 'lucide-react';
import { PHYNTEX_REGISTER, TELEGRAM_PM, INSTAGRAM, TIKTOK } from '../../constants/links';
import { FaInstagram, FaTiktok } from 'react-icons/fa';

function CTASection() {
  return (
    <section 
      id="cta" 
      className="relative z-10 min-h-screen flex items-center justify-center px-3 md:px-10 py-16 overflow-hidden"
    >
      <div className="max-w-4xl mx-auto w-full text-center">
        {/* Header */}
        <div className="mb-12">
          <span className="inline-block px-4 py-2 text-xs font-inter tracking-[0.3em] uppercase text-[#00FF88] border border-[#00FF88]/30 rounded-full mb-4">
            Mulakan Journey
          </span>
          <h2 className="font-teko text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold uppercase leading-[0.95] text-[#F5F5F5] mb-4">
            READY TO <span className="text-[#00FF88]" style={{ textShadow: "0 0 20px rgba(0,255,136,0.5)" }}>TRADE?</span>
          </h2>
          <p className="text-sm md:text-base text-gray-400 font-inter max-w-2xl mx-auto">
            Join thousands of traders worldwide. Start with high leverage and premium trading conditions.
          </p>
        </div>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-12">
          {/* Primary CTA: Phyntex */}
          <a
            href={PHYNTEX_REGISTER}
            target="_blank"
            rel="noopener noreferrer"
            className="cta-primary group relative inline-flex items-center justify-center gap-3 px-8 py-5 bg-[#00FF88] rounded-2xl text-[#0A0A0A] font-teko text-xl md:text-2xl tracking-wider uppercase font-bold transition-all duration-300 hover:scale-105 hover:shadow-2xl w-full sm:w-auto"
            style={{
              boxShadow: "0 0 30px rgba(0,255,136,0.4), 0 0 60px rgba(0,255,136,0.2)"
            }}
          >
            <span>Register CXM</span>
            <div className="flex flex-col items-start text-left">
              <span className="text-[10px] font-inter normal-case font-normal opacity-80">
                Leverage 1:2000
              </span>
            </div>
            {/* Pulse Animation */}
            <div 
              className="absolute inset-0 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none"
              style={{
                boxShadow: "0 0 40px rgba(0,255,136,0.6), 0 0 80px rgba(0,255,136,0.3)"
              }}
            />
          </a>

          {/* Secondary CTA: Telegram PM */}
          <a
            href={TELEGRAM_PM}
            target="_blank"
            rel="noopener noreferrer"
            className="cta-secondary group relative inline-flex items-center justify-center gap-3 px-8 py-5 rounded-2xl text-[#F5F5F5] font-teko text-xl md:text-2xl tracking-wider uppercase font-bold border-2 border-[#00FF88]/40 transition-all duration-300 hover:bg-[#00FF88]/10 hover:border-[#00FF88] w-full sm:w-auto"
            style={{
              background: "rgba(10,10,10,0.6)",
              backdropFilter: "blur(20px)"
            }}
          >
            <MessageCircle size={24} className="text-[#00FF88]" />
            <span>PM to Join Group</span>
          </a>
        </div>

        {/* Additional Info */}
        <div className="mb-12">
          <p className="text-xs md:text-sm text-gray-500 font-inter mb-4">
            Dapatkan trading signals, analysis, dan support dari community.
          </p>
          <div className="flex flex-wrap justify-center gap-3 text-xs text-gray-600 font-inter">
            <span className="flex items-center gap-1">
              <div className="w-2 h-2 rounded-full bg-[#00FF88]" />
              Fast Execution
            </span>
            <span className="flex items-center gap-1">
              <div className="w-2 h-2 rounded-full bg-[#00FF88]" />
              Low Spreads
            </span>
            <span className="flex items-center gap-1">
              <div className="w-2 h-2 rounded-full bg-[#00FF88]" />
              24/7 Support
            </span>
          </div>
        </div>

        {/* Social Links */}
        <div className="border-t border-gray-800 pt-8">
          <div className="flex items-center justify-center gap-6 mb-4">
            <a 
              href={INSTAGRAM} 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-gray-500 hover:text-[#00FF88] transition-colors duration-300"
              aria-label="Instagram"
            >
              <FaInstagram size={24} />
            </a>
            <a 
              href={TIKTOK} 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-gray-500 hover:text-[#00FF88] transition-colors duration-300"
              aria-label="TikTok"
            >
              <FaTiktok size={24} />
            </a>
          </div>
          <p className="text-[10px] text-gray-700 font-inter tracking-wider">
            &copy; {new Date().getFullYear()} HELLOASYROL. All rights reserved.
          </p>
        </div>
      </div>

      {/* Animated Pulse Background */}
      <div 
        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-96 h-96 pointer-events-none opacity-10"
        style={{
          background: "radial-gradient(circle, rgba(0,255,136,0.3) 0%, transparent 70%)",
          filter: "blur(80px)"
        }}
      />

      {/* CSS for Pulse Animation */}
      <style>{`
        @keyframes ctaPulse {
          0%, 100% {
            box-shadow: 0 0 30px rgba(0,255,136,0.4), 0 0 60px rgba(0,255,136,0.2);
          }
          50% {
            box-shadow: 0 0 40px rgba(0,255,136,0.6), 0 0 80px rgba(0,255,136,0.3);
          }
        }
        .cta-primary {
          animation: ctaPulse 2.5s ease-in-out infinite;
        }
      `}</style>
    </section>
  );
}

export default CTASection;
